// extracted by mini-css-extract-plugin
export default {"logo":"Brand_logo__WyBJC","mark":"Brand_mark__katoH"};